import { PracticeExerciseApi } from "../openapi";
import openApiConfig from "./http_service";

const practiceExerciseApi=new PracticeExerciseApi(openApiConfig)

export default practiceExerciseApi